import { useEffect } from 'react';
import { useCurrentAccountId } from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import { buildAccountDataRequest } from './utils';

const useGetAccount = () => {
  const accountId = useCurrentAccountId();

  const {
    data: accountData,
    loading: isFetchingAccount,
    doFetch: doGetAccountDataFetch,
  } = useDataApi();

  useEffect(() => {
    if (!accountId) return;

    doGetAccountDataFetch(buildAccountDataRequest(accountId));
  }, [accountId, doGetAccountDataFetch]);

  return {
    accountData,
    isFetchingAccount,
  };
};

export default useGetAccount;
